import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import PropertyTypesList from './PropertyTypesList'
import AuthContext from 'context/AuthContext'

const PropertyTypes = () => {
  // const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'property_type_manager') ?? {}
  const [page] = useState(1)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [categoryList, setCategoryList] = useState([])
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })

  const allCategory = async data => {
    try {
      var path = apiPath.propertyTypesList
      const result = await apiGet(path, {})
      var response = result?.data?.results
      const resultStatus = result?.data?.success
      setCategoryList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allCategory()
  }, [])

  return (
    <>
      {' '}
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <PropertyTypesList
              categoryList={categoryList}
              page={page}
              allCategory={allCategory}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default PropertyTypes
